module.exports = __webpack_public_path__ + "static/img/award3.a0de9e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/award3.png
// module id = GVm5
// module chunks = 0